export const SERVICES = [
    {
        slug: "cartao-de-visita",
        name: "Cartões de Visita",
        short: "Materiais profissionais para fortalecer sua apresentação.",
        image: "/images/cartoes.jpg",
        seoTitle: "Cartões de Visita em Campinas | IMPRIMA AKI",
        seoDesc: "Cartões de visita profissionais em Campinas – SP. Laminação, verniz, hot stamping e acabamentos premium. Orçamento rápido pelo WhatsApp.",
        intro: "O cartão de visita ainda é o primeiro material que sua empresa entrega em uma reunião. A IMPRIMA AKI produz cartões de visita em Campinas com acabamento profissional, para que cada contato comece com uma boa impressão.",
        items: [
            "Couchê 300g com laminação fosca ou brilho",
            "Verniz localizado e hot stamping",
            "Cantos arredondados e cortes especiais",
            "Versões para equipes e departamentos",
        ],
        faqs: [
            { q: "Qual a quantidade mínima de cartões?", a: "A quantidade mínima varia conforme o acabamento escolhido. Chame no WhatsApp que indicamos a melhor opção para o seu caso." },
            { q: "Não tenho a arte pronta. E agora?", a: "Sem problema. Envie seu logotipo e as informações pelo WhatsApp que nossa equipe orienta você sobre os próximos passos." },
        ],
    },
    {
        slug: "panfletos",
        name: "Panfletos e Flyers",
        short: "Materiais para campanhas, divulgação e ações comerciais.",
        image: "/images/panfletos.jpg",
        seoTitle: "Panfletos e Flyers em Campinas | IMPRIMA AKI",
        seoDesc: "Impressão de panfletos, flyers e folders em Campinas – SP para campanhas e divulgação. Tiragens flexíveis e orçamento pelo WhatsApp.",
        intro: "Panfletos e flyers continuam sendo uma das formas mais diretas de divulgar promoções, lançamentos e serviços. Produzimos materiais impressos em Campinas com qualidade que valoriza a sua campanha.",
        items: [
            "Flyers e folhetos promocionais",
            "Folders institucionais com dobras",
            "Cardápios e tabelas de preço",
            "Tiragens flexíveis para campanhas locais",
        ],
        faqs: [
            { q: "Vocês imprimem cardápios?", a: "Sim. Produzimos cardápios, tabelas e materiais promocionais em diversos formatos e gramaturas." },
            { q: "Qual o prazo de produção?", a: "O prazo depende da quantidade e do acabamento. Envie os detalhes pelo WhatsApp e receba o prazo junto com o orçamento." },
        ],
    },
    {
        slug: "placas",
        name: "Placas e Sinalização",
        short: "Sinalização, identificação e comunicação visual.",
        image: "/images/placas.jpg",
        seoTitle: "Placas e Sinalização em Campinas | IMPRIMA AKI",
        seoDesc: "Placas em ACM, acrílico e sinalização interna e externa em Campinas – SP. Soluções de comunicação visual para empresas. Orçamento pelo WhatsApp.",
        intro: "Placas bem produzidas organizam ambientes, orientam clientes e reforçam a identidade da sua empresa. A IMPRIMA AKI desenvolve placas e sinalização em Campinas para pontos comerciais, escritórios e indústrias.",
        items: [
            "Placas em ACM e acrílico",
            "Sinalização interna e externa",
            "Letreiros e letras caixa",
            "Placas técnicas e de identificação",
        ],
        faqs: [
            { q: "Vocês fazem a instalação da placa?", a: "Trabalhamos com soluções completas de comunicação visual. Consulte as opções de aplicação e instalação pelo WhatsApp." },
            { q: "Quais materiais estão disponíveis?", a: "ACM, acrílico, PS, PVC e outros materiais conforme a necessidade do projeto." },
        ],
    },
    {
        slug: "banners-e-faixas",
        name: "Banners e Faixas",
        short: "Comunicação de grande impacto para empresas e eventos.",
        image: "/images/banners.jpg",
        seoTitle: "Banners e Faixas em Campinas | IMPRIMA AKI",
        seoDesc: "Banners em lona, faixas promocionais e impressão de grande formato em Campinas – SP. Acabamento reforçado. Orçamento rápido pelo WhatsApp.",
        intro: "Para anunciar uma inauguração, promoção ou evento, banners e faixas entregam visibilidade imediata. Produzimos impressão de grande formato em Campinas com acabamento resistente para uso interno e externo.",
        items: [
            "Banners em lona com ilhós e acabamento reforçado",
            "Faixas para promoções e eventos",
            "Impressão de grande formato em alta resolução",
            "Materiais para pontos de venda",
        ],
        faqs: [
            { q: "O banner pode ficar na rua?", a: "Sim. Utilizamos materiais e acabamentos adequados para uso externo. Informe o local de aplicação no seu pedido." },
            { q: "Qual o tamanho máximo?", a: "Trabalhamos com grandes formatos. Envie a medida desejada pelo WhatsApp que confirmamos a viabilidade." },
        ],
    },
    {
        slug: "adesivos",
        name: "Adesivos",
        short: "Personalização, divulgação e identificação.",
        image: "/images/adesivos.jpg",
        seoTitle: "Adesivos Personalizados em Campinas | IMPRIMA AKI",
        seoDesc: "Adesivos de recorte, vinil transparente, fosco e microperfurado em Campinas – SP. Adesivação de vitrines, paredes e rótulos. Orçamento pelo WhatsApp.",
        intro: "Adesivos são versáteis: divulgam a marca, identificam produtos e transformam vitrines e paredes. A IMPRIMA AKI produz adesivos personalizados em Campinas com recorte eletrônico e impressão de alta definição.",
        items: [
            "Adesivos de recorte eletrônico",
            "Vinil transparente, fosco e microperfurado",
            "Adesivação de vitrines e paredes",
            "Rótulos e etiquetas personalizadas",
        ],
        faqs: [
            { q: "Vocês aplicam o adesivo no local?", a: "Para projetos de adesivação em Campinas e região, consulte a disponibilidade de aplicação pelo WhatsApp." },
            { q: "Fazem adesivos em pequenas quantidades?", a: "Sim. A quantidade mínima varia conforme o tipo de adesivo. Envie sua necessidade que indicamos a melhor solução." },
        ],
    },
    {
        slug: "camisetas-personalizadas",
        name: "Camisetas Personalizadas",
        short: "Sublimação e serigrafia para marcas, equipes e campanhas.",
        image: "/images/camisetas.jpg",
        seoTitle: "Camisetas Personalizadas em Campinas | IMPRIMA AKI",
        seoDesc: "Camisetas personalizadas em Campinas – SP com sublimação e serigrafia. Estampas para eventos, equipes e campanhas. Orçamento pelo WhatsApp.",
        intro: "Camisetas personalizadas vestem equipes, promovem eventos e transformam clientes em divulgadores da marca. Trabalhamos com sublimação e serigrafia em Campinas para diferentes quantidades e tipos de tecido.",
        items: [
            "Sublimação em tecidos de poliéster",
            "Serigrafia em camisetas de algodão",
            "Estampas para eventos e campanhas",
            "Tiragens para equipes e revenda",
        ],
        faqs: [
            { q: "Qual a diferença entre sublimação e serigrafia?", a: "A sublimação é ideal para poliéster e estampas coloridas sem toque; a serigrafia funciona muito bem em algodão e tiragens maiores. Orientamos a melhor técnica para o seu projeto." },
            { q: "Qual a quantidade mínima?", a: "Depende da técnica escolhida. Chame no WhatsApp com a quantidade desejada que montamos o orçamento." },
        ],
    },
    {
        slug: "uniformes",
        name: "Uniformes Profissionais",
        short: "Personalização para empresas e equipes.",
        image: "/images/uniformes.jpg",
        seoTitle: "Uniformes Personalizados em Campinas | IMPRIMA AKI",
        seoDesc: "Uniformes personalizados para empresas em Campinas – SP. Camisetas, polos e aventais com a identidade da sua marca. Orçamento pelo WhatsApp.",
        intro: "Uma equipe uniformizada transmite organização e confiança para o cliente. A IMPRIMA AKI produz uniformes personalizados em Campinas para empresas, comércios e equipes de diferentes tamanhos.",
        items: [
            "Camisetas e polos personalizadas",
            "Aventais e peças para operação",
            "Padronização para equipes comerciais",
            "Reposição facilitada para novos colaboradores",
        ],
        faqs: [
            { q: "Vocês atendem empresas com equipes pequenas?", a: "Sim. Atendemos desde pequenas equipes até operações maiores. Envie a quantidade de peças pelo WhatsApp." },
            { q: "Posso repetir o pedido depois?", a: "Sim. Guardamos as especificações do seu projeto para facilitar reposições futuras." },
        ],
    },
    {
        slug: "fachadas",
        name: "Fachadas Comerciais",
        short: "Soluções de comunicação visual para pontos comerciais.",
        image: "/images/fachadas.jpg",
        seoTitle: "Fachadas e Letreiros em Campinas | IMPRIMA AKI",
        seoDesc: "Fachadas comerciais, letreiros em ACM e adesivação de vitrines em Campinas – SP. Comunicação visual para o seu ponto comercial. Orçamento pelo WhatsApp.",
        intro: "A fachada é o cartão de visitas do seu ponto comercial. A IMPRIMA AKI desenvolve soluções de comunicação visual para fachadas em Campinas e região, do letreiro à adesivação da vitrine.",
        items: [
            "Letreiros e painéis em ACM",
            "Letras caixa e elementos iluminados",
            "Adesivação de vitrines",
            "Projetos para pontos comerciais",
        ],
        faqs: [
            { q: "Vocês fazem o projeto da fachada?", a: "Sim. Envie fotos e medidas do seu ponto pelo WhatsApp que nossa equipe analisa e propõe a melhor solução." },
            { q: "Atendem cidades vizinhas?", a: "Sim. Atendemos Campinas e região. Consulte a disponibilidade para a sua cidade." },
        ],
    },
    {
        slug: "envelopamento-automotivo",
        name: "Envelopamento Automotivo",
        short: "Transforme veículos em mídia para sua empresa.",
        image: "/images/envelopamento.jpg",
        seoTitle: "Envelopamento Automotivo em Campinas | IMPRIMA AKI",
        seoDesc: "Envelopamento e adesivação de veículos e frotas em Campinas – SP. Transforme seu veículo em mídia para a sua empresa. Orçamento pelo WhatsApp.",
        intro: "Um veículo envelopado circula pela cidade divulgando sua empresa todos os dias. A IMPRIMA AKI realiza envelopamento e adesivação automotiva em Campinas para carros, utilitários e frotas comerciais.",
        items: [
            "Envelopamento parcial e total",
            "Adesivação de frota com identidade da marca",
            "Recortes e aplicações personalizadas",
            "Projetos para veículos comerciais",
        ],
        faqs: [
            { q: "O envelopamento danifica a pintura?", a: "Quando aplicado e removido corretamente, o vinil protege a pintura original do veículo." },
            { q: "Vocês envelopam frota inteira?", a: "Sim. Desenvolvemos projetos para frotas com padronização visual entre os veículos. Solicite uma cotação pelo WhatsApp." },
        ],
    },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
